// extracted by mini-css-extract-plugin
module.exports = {"social-card-schedule-checkbox":"social-card-schedule_social-card-schedule-checkbox__3xsPH"};